import Card from 'components/Layout/Card';
import React, { useEffect, useState } from 'react';
import MentorshipStatisticsChart from './MentorshipStatisticsChart';
import MembersAnalyticsPieChart from './MembersAnalyticsPieChart';
import Feedback from 'pages/Common/NetworkManagement/Feedback';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import CountryAnalyticsChart from './CountryAnalyticsChart';
import './MembershipResourceTab.scss';
import AllReports from 'pages/Admin/Reports/AllReports';
import { useSelector } from 'react-redux';

const MembershipResourceTab = ({ commonYear, isReport }) => {
  const params = useParams();
  const navigate = useNavigate();
  const [tabType, setTabType] = useState('0');
  const activeClass = 'p-3 bg-new-car color-white text-16-500';
  const inActiveClass = 'p-3 color-dark-blue text-16-500 pointer';
  const location = useLocation();
  const stateData = location?.state?.tabValue;

  const { feedBackCount } = useSelector((state) => ({
    feedBackCount: state.global.feedBackCount,
  }));

  useEffect(() => {
    if (stateData) {
      setTabType(stateData);
    } else {
      setTabType('0');
    }
  }, [stateData]);

  return (
    <>
      <div id="membership-resourcetab-container">
        <Card className="mt-3">
          <div className="d-flex align-items-center flex-wrap gap-2">
            <div
              className={tabType === '0' ? activeClass : inActiveClass}
              onClick={() => {
                setTabType('0');
              }}
            >
              Mentorship Statistics{' '}
            </div>

            <div
              className={tabType === '1' ? activeClass : inActiveClass}
              onClick={() => {
                setTabType('1');
              }}
            >
              IFERP Member’s Analytics
            </div>
            <div
              className={tabType === '2' ? activeClass : inActiveClass}
              onClick={() => {
                setTabType('2');
              }}
            >
              Country Wise Analytics
            </div>

            <div
              className={`${
                tabType === '3' ? activeClass : inActiveClass
              } d-flex gap-2 align-items-center justify-content-center`}
              onClick={() => {
                setTabType('3');
              }}
            >
              Recent Feedback
              <span
                className={
                  tabType === '3'
                    ? 'feedback-unread-count'
                    : 'feedback-unread-count-dark'
                }
              >
                {feedBackCount ? feedBackCount : 0}
              </span>
            </div>
          </div>
        </Card>
        {tabType === '0' && <MentorshipStatisticsChart />}

        {tabType === '1' && (
          <MembersAnalyticsPieChart
            commonYear={commonYear}
            isReport={isReport}
          />
        )}

        {tabType === '2' && (
          <CountryAnalyticsChart commonYear={commonYear} isReport={isReport} />
        )}

        {tabType === '3' && (
          <Card className="mt-3 cps-18 cpe-18 cpt-28 cpb-56">
            {/* filterKey Manage For Top 5 Data Get */}
            <Feedback filterKey="membership" />
            <div
              className="cmt-26 color-new-car text-16-500-20 d-flex justify-content-center align-items-center"
              onClick={() => navigate('/resource/network-management/feedback')}
            >
              View All Feedback
            </div>
          </Card>
        )}
      </div>
      {params?.type === 'overall-report' && tabType === '2' && <AllReports />}
    </>
  );
};

export default MembershipResourceTab;
